import { faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useShowKhelo } from 'utils/HooksUtils';

export default function Card({
  heading,
  status,
  content,
  icon,
  contentHeader,
  isCoach,
  date,
  location,
  sportSpecificKit,
  firstCol = false,
  locationText = 'Verification Centre Location',
}) {
  const isKhelo = useShowKhelo();
  return (
    <div
      data-cy="verification_collection_card"
      className={`flex flex-col ${firstCol ? 'md:pr-6' : ''} ${
        isKhelo ? 'max-w-fill md:w-1/2 mb-4' : 'max-w-full'
      } bg-white ${isKhelo ? '' : 'px-6 py-4'} font-bold font-roboto rounded-lg`}
    >
      <h1 data-cy="verification_collection_heading" className=" leading-6 text-tertiary-150">
        {heading}
      </h1>
      <div
        className={`h-full ${
          isKhelo
            ? `px-2 pt-1 md:px-4 md:pt-4 ${location ? 'md:pb-0' : 'md:pb-4'}`
            : 'px-4 pt-4 pb-5'
        } mt-2 border rounded-md border-fade-gray`}
      >
        <div
          className={`flex gap-7 items-center ${isCoach ? 'border-b pb-3' : ''}   border-fade-gray`}
        >
          <div>
            <img className="min-w-min" src={icon} alt="card icon" />
          </div>
          <div className="w-full ml-4">
            <div className="pb-2 md:pb-0 mt-1">
              <span
                data-cy="content_header"
                className="text-xxs md:text-small xl:text-small text-gray-450 block"
              >
                {contentHeader}
              </span>
              <div className="flex">
                <p data-cy="content" className="m-0 p-0 text-small md:text-sm inline-block">
                  {content}
                </p>
              </div>
              {isKhelo && (
                <div data-cy="date" className="text-xxs mt-2 text-gray-450">
                  {date}
                </div>
              )}
            </div>
            <div className="pb-2 md:pb-0 mt-1">
              <span
                data-cy="status_header"
                className="flex justify-between text-gray-450 text-xxs md:text-small xl:text-small"
              >
                <span>Status</span>
                {location && <span className="md:hidden inline">{locationText}</span>}
              </span>
              <div className="flex justify-between">
                <p
                  data-cy="status"
                  className={`text-small md:text-sm xl:text-smd ${
                    isKhelo ? 'text-blue-kheloBlue' : 'text-purple-550'
                  } inline-block`}
                >
                  {status}
                </p>
                {location && (
                  <a
                    href={location}
                    target="_blank"
                    rel="noreferrer"
                    className="cursor-pointer"
                    title={locationText}
                  >
                    <FontAwesomeIcon icon={faMapMarkedAlt} />
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 48 48"
                      className="w-8 h-8 md:w-10 md:h-10"
                    >
                      <path
                        fill="#48b564"
                        d="M35.76,26.36h0.01c0,0-3.77,5.53-6.94,9.64c-2.74,3.55-3.54,6.59-3.77,8.06	C24.97,44.6,24.53,45,24,45s-0.97-0.4-1.06-0.94c-0.23-1.47-1.03-4.51-3.77-8.06c-0.42-0.55-0.85-1.12-1.28-1.7L28.24,22l8.33-9.88	C37.49,14.05,38,16.21,38,18.5C38,21.4,37.17,24.09,35.76,26.36z"
                      />
                      <path
                        fill="#fcc60e"
                        d="M28.24,22L17.89,34.3c-2.82-3.78-5.66-7.94-5.66-7.94h0.01c-0.3-0.48-0.57-0.97-0.8-1.48L19.76,15	c-0.79,0.95-1.26,2.17-1.26,3.5c0,3.04,2.46,5.5,5.5,5.5C25.71,24,27.24,23.22,28.24,22z"
                      />
                      <path
                        fill="#2c85eb"
                        d="M28.4,4.74l-8.57,10.18L13.27,9.2C15.83,6.02,19.69,4,24,4C25.54,4,27.02,4.26,28.4,4.74z"
                      />
                      <path
                        fill="#ed5748"
                        d="M19.83,14.92L19.76,15l-8.32,9.88C10.52,22.95,10,20.79,10,18.5c0-3.54,1.23-6.79,3.27-9.3	L19.83,14.92z"
                      />
                      <path
                        fill="#5695f6"
                        d="M28.24,22c0.79-0.95,1.26-2.17,1.26-3.5c0-3.04-2.46-5.5-5.5-5.5c-1.71,0-3.24,0.78-4.24,2L28.4,4.74	c3.59,1.22,6.53,3.91,8.17,7.38L28.24,22z"
                      />
                    </svg> */}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        {sportSpecificKit && !isKhelo ? (
          <div className=" mt-3 pt-2 border-t-1 border-gray-150">
            <p className="text-small font-bold text-tertiary-150">Sports Specific Kit</p>
            <div className="flex items-center justify-between">
              <div>
                <span className="text-gray-450 text-xxs">Status</span>
                <p
                  data-cy="sports_specific_kit_status"
                  className={`text-small ${
                    isKhelo ? 'text-blue-kheloBlue' : 'text-purple-550'
                  } py-1`}
                >
                  {sportSpecificKit.status}
                </p>
              </div>
              <div>
                <p className="text-gray-450 text-xxs">Remarks</p>
                <span
                  data-cy="sports_specific_kit_remarks"
                  className="text-pink-700 text-xs bg-fade-pink  py-1"
                >
                  {sportSpecificKit.remark}
                </span>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
